import { TOGGLE_MODAL } from '../actions/modals';

/**
 * Create a selector (to be used with take from redux-saga)
 * to handle closing specific modal
 * @param {String} modalName
 * @returns {Function}
 */
export const isModalClosed = (modalName) =>
  /**
   * Test if action match with closing specific modal
   * @param {Object} action
   * @param {String} action.type
   * @param {String} action.key
   * @param {Boolean} action.value
   */
  ({ type, key, value }) => type === TOGGLE_MODAL && key === modalName && value === false;

/**
 * Create a selector (to be used with take from redux-saga)
 * to handle closing specific modal
 * @param {String} modalName
 * @returns {Function}
 */
export const isModalOpened = (modalName) =>
  /**
   * Test if action match with closing specific modal
   * @param {Object} action
   * @param {String} action.type
   * @param {String} action.key
   * @param {Boolean} action.value
   */
  ({ type, key, value }) => type === TOGGLE_MODAL && key === modalName && value === true;
